import React, { Fragment, useState } from 'react';
import { Transition } from '@headlessui/react'; // 1. Импортируем компонент

const RadioPlayerPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPlayerLoaded, setIsPlayerLoaded] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isPlayerLoaded) {
      setIsPlayerLoaded(true);
    }
  };

  const popupBaseClasses = "fixed bottom-14 right-0 md:right-2 z-40 w-full sm:max-w-[440px] lg:max-w-[520px] bg-[#fdf6e3] shadow-md overflow-hidden font-mono";

  return (
    <Fragment>
      <Transition
        as={Fragment}
        show={isOpen}
        enter="transition-all ease-out duration-300"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition-all ease-in duration-200"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <div className={`${popupBaseClasses} pointer-events-none`}>
          <div className="py-2 px-3 font-elegant text-base-14 leading-5 text-gray">
            <p>Free ambient electronic and deep techno online radio stream.</p>
            <p>Powered by <a href="https://9128.live" target="_blank" rel="noopener noreferrer" className=" hover:text-black">9128.live</a></p>
          </div>
        </div>
      </Transition>

      {isPlayerLoaded && (
        <div
          className={`
            ${popupBaseClasses}
            transition-opacity duration-300
            ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}
          `}
        >
          <div className="h-[52px]">
            <div className="py-2 px-3 font-elegant text-sm md:text-base-14 !leading-5 text-gray">
              <p>Free ambient electronic and deep techno online radio stream.</p>
              <p>Powered by <a href="https://9128.live" target="_blank" rel="noopener noreferrer" className=" hover:text-black">9128.live</a></p>
            </div>
          </div>

          <iframe
            src="https://embed.radio.co/player/d055ca7.html"
            width="100%"
            allow="autoplay"
            className="pb-2 px-3 overflow-hidden h-[110px] scroll-hidden block w-full items-start"
            title="Radio Player"
          />
        </div>
      )}

      {/* 3. КНОПКА УПРАВЛЕНИЯ (остается без изменений) */}
      <button
        onClick={handleToggle}
        aria-label={isOpen ? 'Закрыть плеер' : 'Открыть плеер'}
        aria-expanded={isOpen}
        className="fixed bottom-2 right-2 z-50 flex h-10 w-10 items-center justify-center bg-[#cba352] text-white transition-transform duration-200 hover:scale-105"
      >
        {isOpen ? '✕' : <Svg />}
      </button>
    </Fragment>
  );
};

export default RadioPlayerPopup;

const Svg = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5588 10.5334C19.5588 7.99823 18.5517 5.56693 16.7591 3.77432C14.9665 1.98172 12.5352 0.97464 10 0.97464C7.4649 0.97464 5.03361 1.98172 3.241 3.77432C1.44839 5.56693 0.441315 7.99823 0.441315 10.5334C0.964445 10.5333 1.4722 10.3564 1.88214 10.0314C2.29209 9.70646 2.58016 9.25246 2.6996 8.74315C3.10158 7.1078 4.04026 5.65446 5.36557 4.61547C6.69087 3.57647 8.32627 3.01184 10.0103 3.01184C11.6943 3.01184 13.3297 3.57647 14.655 4.61547C15.9803 5.65446 16.919 7.1078 17.321 8.74315C17.4408 9.25229 17.7289 9.70607 18.1388 10.031C18.5487 10.3559 19.0562 10.5329 19.5793 10.5334H19.5588Z" stroke="#FFFAED" stroke-width="0.8" stroke-linejoin="round" />
      <path d="M0.441452 10.5334V15.0376C0.441452 15.1537 0.464353 15.2687 0.508846 15.3759C0.553338 15.4832 0.618548 15.5806 0.700739 15.6626C0.782931 15.7446 0.880491 15.8095 0.987833 15.8538C1.09517 15.898 1.21019 15.9207 1.32629 15.9204H1.49464" stroke="#FFFAED" stroke-width="0.8" stroke-linejoin="round" />
      <path d="M2.06532 14.2164H3.2848V17.6347H2.06532C1.91341 17.6347 1.76772 17.5743 1.6603 17.4669C1.55289 17.3595 1.49254 17.2138 1.49254 17.0619V14.7831C1.49416 14.6322 1.55522 14.4881 1.66247 14.382C1.76971 14.2759 1.91447 14.2164 2.06532 14.2164Z" stroke="#FFFAED" stroke-width="0.8" stroke-linejoin="round" />
      <path d="M3.68928 12.6192H4.23949C4.40394 12.6192 4.56679 12.6516 4.71873 12.7145C4.87067 12.7775 5.00872 12.8697 5.12501 12.986C5.2413 13.1023 5.33355 13.2403 5.39648 13.3923C5.45942 13.5442 5.49181 13.7071 5.49181 13.8715V17.9775C5.49181 18.3096 5.35987 18.6282 5.12501 18.863C4.89016 19.0979 4.57162 19.2298 4.23949 19.2298H3.68928C3.58039 19.2298 3.47595 19.1866 3.39895 19.1096C3.32195 19.0326 3.27869 18.9281 3.27869 18.8192V13.0216C3.27869 12.9127 3.32195 12.8083 3.39895 12.7313C3.47595 12.6543 3.58039 12.611 3.68928 12.611V12.6192Z" stroke="#FFFAED" stroke-width="0.8" stroke-linejoin="round" />
      <path d="M19.5589 10.5334V15.0376C19.5589 15.2717 19.4659 15.4963 19.3004 15.6618C19.1348 15.8274 18.9103 15.9204 18.6761 15.9204H18.5057" stroke="#FFFAED" stroke-width="0.8" stroke-linejoin="round" />
      <path d="M17.935 17.6306H16.7155V14.2123H17.935C18.0869 14.2123 18.2326 14.2727 18.34 14.3801C18.4474 14.4875 18.5078 14.6332 18.5078 14.7851V17.0639C18.5061 17.2148 18.4451 17.3589 18.3378 17.465C18.2306 17.5711 18.0858 17.6306 17.935 17.6306Z" stroke="#FFFAED" stroke-width="0.8" stroke-linejoin="round" />
      <path d="M16.3151 19.2278H15.7711C15.439 19.2278 15.1204 19.0958 14.8856 18.861C14.6507 18.6261 14.5188 18.3076 14.5188 17.9755V13.8695C14.5188 13.5373 14.6507 13.2188 14.8856 12.984C15.1204 12.7491 15.439 12.6172 15.7711 12.6172H16.3151C16.424 12.6172 16.5285 12.6604 16.6055 12.7374C16.6825 12.8144 16.7257 12.9189 16.7257 13.0278V18.8254C16.7236 18.9329 16.6794 19.0352 16.6026 19.1104C16.5258 19.1857 16.4226 19.2278 16.3151 19.2278Z" stroke="#FFFAED" stroke-width="0.8" stroke-linejoin="round" />
    </svg>
  )
}